import { render } from "./terms&condition.vue?vue&type=template&id=31beadda&ts=true"
import script from "./terms&condition.vue?vue&type=script&lang=ts"
export * from "./terms&condition.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__